import Vue from 'vue'
// @ts-ignore
import VueVirtualScroller, { DynamicScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.use(VueVirtualScroller)
